export default __webpack_public_path__ + "static/media/instagram.574dd582.svg";